"use client";
import { Tooltip as e } from "../tooltip/Tooltip.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/controls/ControlHint.tsx
var n = ({ children: n, label: r }) => r ? /* @__PURE__ */ t(e, {
	trigger: n,
	content: r
}) : n;
//#endregion
export { n as ControlHint };
